import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const table = css `
  ${styleUtils.borderBox}
  width: 100%;
  border-collapse: collapse;
  ${theme.typeStyles.bodySmallStyles}
`;
const defaultProps = {
    className: '',
};
const Table = ({ children, className = defaultProps.className, }) => (_jsx("table", Object.assign({ className: className, css: table }, { children: children })));
const MemoizedTable = memo(Table);
export { MemoizedTable as Table };
// MC-1068 Temporary hack for Storybook.
export default Table;
